import {Injectable, NgZone} from '@angular/core';
import { Router } from '@angular/router';
import {Session} from "../../shared/domain/session";
import {CookieService} from "angular2-cookie"

@Injectable()
export class AuthenticationService {
    projectKey = 'tickets_informatica_';
    idGoogleKey = this.projectKey + 'idGoogle';
    nameKey = this.projectKey + 'name';
    imgKey = this.projectKey + 'imgUrl';
    emailKey = this.projectKey + 'email';
    typekey = this.projectKey + 'type';
    idkey = this.projectKey + 'id_user';

    constructor(private router: Router, public cookies: CookieService, private ngZone: NgZone) { }

    login(session: Session) {
        this.setCookies(session);
        this.goToDashboard(session.url)
    }

    logout() {
        this.removeCookies();
        this.router.navigate(['/']);
    }

    public setCookies(session){

        this.cookies.put(this.idGoogleKey, session.idGoogle);
        this.cookies.put(this.emailKey, session.email);
        this.cookies.put(this.nameKey, session.name);
        this.cookies.put(this.imgKey, session.imgUrl);
        this.cookies.put(this.typekey, session._type);
        this.cookies.put(this.idkey, session.id);
        /*
        const days = 20; //Expirará a los 20 días
        const d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();

        document.cookie = this.tokenKey + '=' + session.token + ';' + expires + ';path=/';
        document.cookie = this.emailKey + '=' + session.email + ';' + expires + ';path=/';
        document.cookie = this.nameKey + '=' + session.name + ';' + expires + ';path=/';
        document.cookie = this.imgKey + '=' + session.imgUrl + ';' + expires + ';path=/';*/

    }

    public getCookies(key){
        switch (key){
            case 'idGoogle':
                return this.cookies.get(this.idGoogleKey);
            case 'email':
                return this.cookies.get(this.emailKey);
            case 'name':
                return this.cookies.get(this.nameKey);
            case 'imgUrl':
                return this.cookies.get(this.imgKey);
            case 'type':
                return this.cookies.get(this.typekey);
            case 'idUser':
                return this.cookies.get(this.idkey);
        }
    }

    public getAllCookies() {
        const session =  {
            idGoogle: this.getCookies('idGoogle'),
            email: this.getCookies('email'),
            name: this.getCookies('name'),
            imgUrl: this.getCookies('imgUrl'),
            id: this.getCookies('idUser'),
            type: this.getCookies('type')
        }
        return session;
    }

    public removeCookies()
    {
        this.cookies.remove(this.idGoogleKey);
        this.cookies.remove(this.emailKey);
        this.cookies.remove(this.nameKey);
        this.cookies.remove(this.imgKey);
        this.cookies.remove(this.typekey);
        this.cookies.remove(this.idkey);

        /*
        // Para exploradores viejos y los nuevos, acepta solamente cambiar la fecha de expiración a más vieja.
        document.cookie = this.tokenKey + '=' +';expires=' + new Date(1970, 0, 1).toUTCString() + ';path=/'
        document.cookie = this.emailKey + '=' +';expires=' + new Date(1970, 0, 1).toUTCString() + ';path=/'
        document.cookie = this.nameKey + '=' +';expires=' + new Date(1970, 0, 1).toUTCString() + ';path=/'
        document.cookie = this.imgKey + '=' +';expires=' + new Date(1970, 0, 1).toUTCString() + ';path=/'
        */
    }

    public isAuthenticated(): boolean {
        // TODO: Check whether the token is expired and return
        // true or false
        const token = '/(?:(?:^|.*;\s*)' + this.idGoogleKey + '\s*\=\s*([^;]*).*$)|^.*$/';
        const cookieValue = document.cookie.replace(token, "$1");
        return cookieValue != "";
    }

    validateType(type: string): void {
        const url = this.getCookies('type');
        if (type !== url) {
            this.goToDashboard(url);
        }
    }

    goToDashboard(url){
        this.ngZone.run(() => {
                this.router.navigate([url]);
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/core/services/authentication.service.ts